<template>
  <div class="upLoadBox">
    <div class="uploadContent">
      <div class="upLoadTop">
        上传视频
        <img src="/static/images/closeIcon.png" alt="" @click="close">
      </div>
      <div class="upLoadBottom">
        <div class="upLoadSelect">
          <div class="upLoadTitle">选择：</div>
          <div class="upLoadSelItem uploadSelBtn">
            <Dropdown trigger="click" @on-click="choseGrade" placement="bottom-start">
              <Button type="primary">
                {{gradeName}}
                <Icon type="md-arrow-dropdown" />
              </Button>
              <DropdownMenu slot="list">
                <DropdownItem divided name="年级">{{'年级'}}</DropdownItem>
                <DropdownItem divided v-for="(item,index) in gradeInfo" :key="index" :name="item.name">{{item.name}}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <Dropdown trigger="click" style="margin-left: 20px" @on-click="choseSubject" placement="bottom-start">
              <Button type="primary">
                {{subjectName}}
                <Icon type="md-arrow-dropdown" />
              </Button>
              <DropdownMenu slot="list">
                <DropdownItem divided name="学科">{{'学科'}}</DropdownItem>
                <DropdownItem divided v-for="(item,index) in subjectInfo" :key="index" :name="item.name">{{item.name}}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <Dropdown trigger="click" style="margin-left: 20px" @on-click="choseType" placement="bottom-start">
              <Button type="primary">
                {{versionName}}
                <Icon type="md-arrow-dropdown" />
              </Button>
              <DropdownMenu slot="list">
                <DropdownItem divided name="版本">{{'版本'}}</DropdownItem>
                <DropdownItem divided v-for="(item,index) in versionInfo" :key="index" :name="item.name">{{item.name}}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <Dropdown trigger="click" style="margin-left: 20px" @on-click="choseMaterial" placement="bottom-start">
              <Button type="primary">
                {{materialName}}
                <Icon type="md-arrow-dropdown" />
              </Button>
              <DropdownMenu slot="list">
                <DropdownItem divided name="教材">{{'教材'}}</DropdownItem>
                <DropdownItem divided v-for="(item,index) in materialInfo" :key="index" :name="item.name">{{item.name}}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
        <div class="upLoadSelect">
          <div class="upLoadTitle">共享：</div>
          <div class="upLoadSelItem">
            <CheckboxGroup v-model="shareArr" @on-change="checkAllGroupChange">
              <Checkbox label="全站" class="upLoadMr"></Checkbox>
              <Checkbox label="区域" class="upLoadMr"></Checkbox>
              <Checkbox label="校本"></Checkbox>
            </CheckboxGroup>
          </div>
        </div>
        <div class="upLoadSelect">
          <div class="upLoadTitle">文件：</div>
          <div class="upLoadSelItem">
            <!-- <Upload action="//jsonplaceholder.typicode.com/posts/">
                            <Button size="small" icon="ios-add" type="primary">Download</Button>
                        </Upload> -->
            <!-- <Button size="small" icon="ios-add" type="primary" id="materialDownLoad" @click="downLoad">Download</Button> -->
            <div id="filePicker">+ 选择文件</div>
            <Progress v-show="isShowPercentage" :percent="percentage" :stroke-width="5" />
            <img :src="imgUpLoad" alt="" class="imgUpLoad" width="100">
            <div>{{upLoadName}}</div>
            <vue-upload ref="uploader" uploadButton="#filePicker" multiple @fileChange="fileChange" @progress="onProgress"
              @success="onSuccess"> </vue-upload>
          </div>
        </div>
        <div class="upLoadSelect">
          <div class="upLoadType "><span style="color:red;">*</span>{{upLoadStyle}} </div>
        </div>
        <div class="upLoadBtn">
          <Button type="primary" shape="circle" class="loadBtn" @click="upLoadAdd">确定</Button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import bus from '../../assets/eventBus/enentBus.js'
  import api from '../../utils/api.js'
  import vueUpload from './uploadBtn'
  import statistic from '../../assets/statistics.js'
  export default {
    name: 'upLoad',
    props:{
      datas:{
        type:Object,
        default:{}
      },
      gradeDatas:{
        type:Array,
        default:[]
      },
      subjectDatas:{
        type:Array,
        default:[]
      },
      versionDatas:{
        type:Array,
        default:[]
      }
    },
    data() {
      return {
        urlHttp: '/testIp',
        url:'',
        boxWidth: null,
        boxHeight: null,
        shareArr: [],
        gradeInfo: null,
        subjectInfo: null,
        versionInfo: null,
        materialInfo: null,
        gradeName: '年级',
        subjectName: '学科',
        versionName: '版本',
        materialName: '教材',
        gradeId: null,
        liveGradeId:null,
        subjectId: null,
        liveSubjectId:null,
        versionId: null,
        materialId: null,
        upLoadId: 'materialDownLoad',
        fileList: [],
        stylelId:1,
        percentage: 0,
        isShowPercentage: false,
        imgUpLoad: null,
        shareNetId:null,
        shareWebsiteId:null,
        shareSchoolId:null,
        teacherId:null,
        upLoadName: '',
        filePath:null,
        fileName:null,
        knowledgeId:null,
        fileSize:null,
        modal1:false,
        gradeIdLong:null,
        subjectIdLong:null,
        resoures:'课件',
        upLoadStyle:'',
        testPaperTypeInfo:null,
        testPaperName:null,
        typeId:null,
        upLoadStyle:'支持文件类型：.mp4 .avi',
        handoutGtId:'1',
        lastTime:0,                                 //防止连点
        materialType:null,                          // 资源类型
      }
    },
    mounted() {
      const that = this;
      this.selectQcrPublic('grade_id')
        this.getMaterialData(this.datas.upLoadGradeId, this.datas.upLoadSubjectId, this.datas.upLoadVersionId)
    },
    methods: {
      sureName(){

      },
      close() {
        this.$emit('closeUpload', false)
      },
      //获取级联年级信息
      selectQcrPublic(columnName,gradeId,subjectId){
        let that = this;
        const url = '/axt-data/qcr/selectQcrFuture';
        if(localStorage.getItem('websiteId') == undefined || localStorage.getItem('websiteId') == null){
          that.websiteId = 0;
        }else{
          that.websiteId = localStorage.getItem('websiteId');
        }
        let params = {
          pageNo:1,
          pageSize:100,
          websiteId:that.websiteId,
          gradeId:gradeId,
          subjectId:subjectId,
          columnName:columnName
        }
        api.getListAPI(url,params).then(res => {

          if(res.data.message == 'success'){
            let list = res.data.data;
            if(columnName == 'grade_id') that.getGradeData(list)
            if(columnName == 'subject_id') that.getSubjectData(list)
            if(columnName == 'version_id') that.getVersionData(list)
          }

         }).catch(err => {console.log(err)})
      },
        //获取年级信息
        getGradeData(list){
            let that = this;
            const url =  '/axt-future/grade/selectByIds';
            let params = {
                gradeIds:list + ''
            }
            api.getListAPI(url,params).then(res => {
                //数据处理
                this.gradeInfo = res.data.data;
                for(let i = 0; i < that.gradeInfo.length; i++){
                  if(that.datas.upLoadGradeId == that.gradeInfo[i].id){
                    that.gradeName = that.gradeInfo[i].name;
                    that.gradeId = that.gradeInfo[i].id;
                    that.gradeIdLong = that.gradeInfo[i].gradeId;
                  }
                }
                that.selectQcrPublic('subject_id',that.gradeId)
             }).catch(err => {console.log(err)})
        },
        //获取学科信息
        getSubjectData(list){
          if(list.indexOf(this.subjectId) == -1){
              this.subjectName = '学科'
          }
            let that = this;
            const url =  '/axt-future/subject/selectByIds';
            let params = {
                subjectIds:list + ''
            }
            api.getListAPI(url,params).then(res => {
                that.subjectInfo = res.data.data;
                for(let j = 0; j < that.subjectInfo.length; j++){
                  if(that.datas.upLoadSubjectId == that.subjectInfo[j].id){
                    that.subjectName = that.subjectInfo[j].name;
                    that.subjectId = that.subjectInfo[j].id;
                    that.subjectIdLong = that.subjectInfo[j].subjectId;
                  }
                }
                that.selectQcrPublic('version_id',that.gradeId,that.subjectId)
            }).catch(err => {
                console.log(err)
            })
        },
        //获取版本信息
        getVersionData(list){
          if(list.indexOf(this.versionId) == -1){
              this.versionName = '版本';
          }
            let that = this;
            const url =  '/axt-future/version/selectByIds';
            let params = {
                versionIds:list + ''
            }
            api.getListAPI(url,params).then(res => {
                that.versionInfo = res.data.data;
                for(let k = 0; k < that.versionInfo.length; k++){
                  if(that.datas.upLoadVersionId == that.versionInfo[k].id){
                    that.versionId = that.datas.upLoadVersionId;
                    that.versionName = that.versionInfo[k].name;
                  }
                }
            }).catch(err => {
                console.log(err)
            })
        },
      choseGrade(name) {
        if(name == '年级'){
          this.gradeIdLong = null;
          this.gradeId = null;
        }
        this.gradeName = name;
        let info = this.gradeInfo;
        for (let i = 0; i < info.length; i++) {
          if (info[i].name == name) {
            this.gradeIdLong = info[i].gradeId;
            this.gradeId = info[i].id;
            this.selectQcrPublic('subject_id',this.gradeId,null)
             this.getMaterialData(this.gradeId, this.subjectId, this.versionId)
          }
        }
      },
      choseSubject(name) {
        if(name == '学科'){
          this.subjectIdLong = null;
          this.subjectId = null;
        }
        this.subjectName = name;
        let info = this.subjectInfo;
        for (let i = 0; i < info.length; i++) {
          if (info[i].name == name) {
            this.subjectId = info[i].id;
            this.subjectIdLong = info[i].subjectId;
            this.selectQcrPublic('version_id',this.gradeId,this.subjectId)
             this.getMaterialData(this.gradeId, this.subjectId, this.versionId)
          }
        }
      },
      choseType(name) {
        this.versionName = name;
        let info = this.versionInfo;
        for (let i = 0; i < info.length; i++) {
          if (info[i].name == name) {
            this.versionId = info[i].id;
            this.getMaterialData(this.gradeId, this.subjectId, this.versionId)
          }
        }
      },
      choseMaterial(name) {
        this.materialName = name;
        let info = this.materialInfo;
        for (let i = 0; i < info.length; i++) {
          if (info[i].name == name) {
            this.knowledgeId = info[i].knowledgeId;
          }
        }
        if(name == '教材'){
          this.knowledgeId = null;
        }
      },
      getMaterialData(gradeId, subjectId, versionId) {
        let that = this;
        const url =  '/axt-future/liveTeaching/pageWithBaseInfo';
        const params = {
          pageSize: 100,
          pageNo: 1,
          gradeIds: gradeId,
          subjectId: subjectId,
          versionId: versionId,
          accurate:1
        }
        api.getListAPI(url, params).then(res => {
          if (res.data.data.total == 0) {
            that.materialInfo = [{
              name: '暂无教材'
            }];
          } else {
            that.materialInfo = res.data.data.rows;
          }
          that.materialName = '教材'

        }).catch(err => {
          console.log(err)
        })
      },
      checkAllGroupChange(data) {
        if(data.length > 0){
          for(let i=0;i<data.length;i++){
            if(data[i] == "全站"){
              this.shareNetId = 1;
            }else if(data[i] == "区域"){
              this.shareWebsiteId = localStorage.getItem("websiteId")
            }else if(data[i] == "校本"){
              this.shareSchoolId = localStorage.getItem("schoolId")
            }
          }
        }
      },
      resouresUrlChange(data){
        if(data == '课件'){
          this.materialType = 3;
          this.url =  '/axt-data/dataPPT/addDataPPT';            //课件
          this.upLoadStyle = '支持文件格式: .ppt/.pptx/.pdf'
        }else if(data == '学案'){
          this.materialType = 4;
          this.url =  '/axt-data/dataLearningPlan/addDataLearningPlan';        //学案
          this.upLoadStyle = '支持文件格式: doc/.docx/.pdf'
        }else if(data == '微课'){
          this.materialType = 1;
          this.url =  '/axt-data/dataVideo/addDataVideo';       //微课
          this.upLoadStyle = '支持文件格式: .mp4/.avi'
        }else if(data == '其他'){
          this.materialType = 5;
          this.url =  '/axt-data/dataAudio/addDataAudio';        //其他
          this.upLoadStyle = '支持文件格式: .mp3'
        }
      },
      fileChange(file) {
        if (!file.size) return;
        this.fileList.push(file);
        this.imgUpLoad = null;
        this.upLoadName = '';
      },
      onSuccess(file, response) {
        if (response.needMerge) {
          api.mergeUpload({
            tempName: response.tempName,
            fileName: file.name
          }).then(res => {
            let $fileStatus = $(`.file-${file.id} .file-status`);
            if (res.status === 0) {
              $fileStatus.html('上传成功，转码中');
            } else if (res.status === 1) {
              $fileStatus.html('上传失败');
            } else if (res.status === 2) {
              $fileStatus.html('上传成功');
            }
          });
        }
        let imgName = response.data;
        if (/\.gif/gi.test(imgName) || /\.jpg/gi.test(imgName) || /\.png/gi.test(imgName) || /\.jpeg/gi.test(imgName)) {
          this.imgUpLoad = 'https://qcban.aixuetang.com/res' + imgName;
          this.upLoadName = '文件名：' + file.name;
        } else {
          this.upLoadName = '文件名：' + file.name;
        }
        this.filePath = response.data;
        this.fileName = file.name;
        this.fileSize = file.size;
        this.isShowPercentage = false;
        this.percentage = 0;
      },
      onProgress(file, percentage) {
        this.percentage = Math.round(percentage * 100);
        if (percentage > 0) {
          this.isShowPercentage = true;
        }
      },
      downLoad() {
        bus.$emit('openUploader', {
          id: '1111' // 传入的参数
        })
      },
      //上传资源
      upLoad(){
        let that = this;
          this.url = '/axt-data/dataVideo/addDataVideo';
          const url = this.urlHttp;
          
          if(this.gradeId < 82){
            this.handoutGtId = '1';
          }else if(this.gradeId < 85){
            this.handoutGtId = '2';
          }else {
            this.handoutGtId = '3';
          }
          var params = {
            subjectId:that.subjectIdLong,
            gradeId:that.gradeIdLong,
            name:that.fileName,
            knowledgeId:that.knowledgeId,
            teacherId:localStorage.getItem('userId'),
            shareNetId:that.shareNetId,
            shareWebsiteId:that.shareWebsiteId,
            shareSchoolId:that.shareSchoolId,
            liveGradeId:that.gradeId,
            liveSubjectId:that.subjectId,
            filePath:that.filePath
          }
          api.postParamsAPI(this.url, params,{headers: {'Content-Type':'application/x-www-form-urlencoded'}}).then(res => {
            if(res.data.message == 'success'){
                this.$Message.info('上传成功')
                let uuid = localStorage.getItem('uuid');
                statistic.statistics(uuid,that.fileName,2,1,3,1,0)       //上传埋点
                setTimeout(function(){
                     that.close()
                },600)

            }


          }).catch(err => {
            console.log(err)
          })
      },
      //上传资源
      upLoadAdd(){
        if(this.gradeIdLong == null){
            this.$Message.warning('年级不能为空');
            return
          }
          if(this.subjectIdLong == null){
            this.$Message.warning('学科不能为空');
            return
          }
          if(this.fileName == null){
            this.$Message.warning('请选择文件');
            return
          }
        const now = new Date().valueOf();
        if(this.lastTime == 0){
            this.upLoad()
            this.lastTime = now

        }else{
          if((now-this.lastTime) > 3000){
            this.upLoad()
          }
        }

      }
    },
    destroyed() {
      bus.$off('fileAdded');
      bus.$off('fileSuccess');
    },
    components: {
      vueUpload
    }
  }
</script>
<style lang="">
  .upLoadBox {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 20;
  }

  .uploadContent {
    width: 954px;
    /* height: 543px; */
    border-radius: 16px;
    background: white;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .upLoadTop {
    width: 100%;
    height: 60px;
    border-bottom: solid 1px #EAECF1;
    line-height: 60px;
    text-align: center;
    position: relative;
    color: #364B5F;
  }

  .upLoadTop img {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 20px;
    right: 20px
  }

  .upLoadTop img:hover {
    cursor: pointer;
  }

  .upLoadBottom {
    width: 90%;
    margin: 38px auto;
  }

  .upLoadSelect {
    display: flex;
    flex-direction: row;
    line-height: 50px;
    margin-bottom: 20px;
  }

  .upLoadSelect .upLoadTitle {
    flex: 1;
    font-size: 14px;
    font-weight: 600;
  }

  .upLoadSelect .upLoadSelItem {
    flex: 8;
    text-align: left;
  }

  .upLoadSelect .upLoadSelItem .ivu-btn {
    font-size: 14px;
    border-radius: none;
  }

  .upLoadSelect .upLoadSelItem .ivu-checkbox-wrapper {
    font-size: 14px;
  }

  .upLoadType {
    font-size: 14px;
    color: #364B5F;
    padding-left: 3%;
  }

  .upLoadBtn {
    text-align: right;
  }

  .loadBtn {
    width: 121px;
    height: 50px;
    background: #E4E9ED;
    color: #7E8995;
    border: none;
    font-size: 16px;
  }

  .uploadSelBtn .ivu-btn {
    background: none;
    border: solid 1px #B8C4CE;
    color: #364B5F;
  }

  .upLoadSelect .ivu-select-dropdown {
    margin: 0;
    padding: 0;
    box-shadow: none;
    border: solid 1px #B8C4CE;
  }

  .upLoadSelect .ivu-upload-list {
    margin-top: 0;
  }

  .upLoadSelect .ivu-upload-list-file {
    font-size: 14px;
  }

  .upLoadSelect .ivu-dropdown .ivu-select-dropdown {
    height: 161px;
    overflow-y: scroll;
  }

  .upLoadSelect .ivu-dropdown-item-divided:before {
    height: 0;
  }

  .upLoadSelect .ivu-dropdown-item-divided {
    margin-top: 0;
  }

  .upLoadSelect .ivu-dropdown-menu {
    background: #FCFCFC;
  }

  .upLoadSelect .ivu-dropdown .ivu-select-dropdown::-webkit-scrollbar {
    width: 4px;
    height: 10px;
  }

  .upLoadSelect .ivu-dropdown .ivu-select-dropdown::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .upLoadSelect .ivu-dropdown .ivu-select-dropdown::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);

  }
  .upLoadMr {
    margin-right: 55px;
  }
</style>



// WEBPACK FOOTER //
// src/components/upLoad/upLoadAreaCourse.vue